import { motion } from 'framer-motion';

const competitors = [
  { name: 'AMIC UGT', price: '150 EUR', weakness: 'ONG sin tecnologia, no escala', threat: 'low' },
  { name: 'SR Abogados', price: '~500 EUR', weakness: 'Despacho clasico, todo manual', threat: 'medium' },
  { name: 'Iberijuridica', price: '299 EUR', weakness: 'Sin IA, sin CRM, sin app', threat: 'medium' },
  { name: 'Agave Abogados', price: '~400 EUR', weakness: 'Buen marketing pero 0 tecnologia', threat: 'low' },
  { name: 'reg-extraordinaria2026.com', price: 'Solo leads', weakness: 'Vende leads crudos, no servicio', threat: 'high' },
];

const differentiators = [
  { feature: 'Pili: IA legal que cualifica en 2 segundos', desc: '87% de precision. Ningun competidor tiene IA legal.' },
  { feature: 'CRM que genera dinero a los abogados', desc: 'No vendemos software, vendemos clientes listos para firmar.' },
  { feature: 'Contratacion sin login en 5 minutos', desc: 'El cliente firma, paga y descarga su contrato sin crear cuenta.' },
  { feature: 'Cuenta bancaria el dia que llegas a Espana', desc: 'ES-IBAN con solo pasaporte. Ningun competidor lo ofrece.' },
  { feature: 'Remesas 60-75% mas baratas que Western Union', desc: 'Blockchain hace que enviar 500 EUR cueste 3 EUR, no 15.' },
  { feature: 'Habla tu idioma: espanol, ingles, frances, arabe', desc: '4 idiomas con soporte RTL. El mercado arabe esta desatendido.' },
  { feature: 'Solo 2-3 abogados por zona', desc: 'Exclusividad real. El abogado sabe que no compite contra 50 mas.' },
  { feature: 'Leads que llegan calientes, no frios', desc: 'Pili ya filtro, el call center ya confirmo. El abogado solo cierra.' },
];

const threatColor: Record<string, string> = {
  low: 'bg-emerald-500/20 text-emerald-400',
  medium: 'bg-orange-500/20 text-orange-400',
  high: 'bg-red-500/20 text-red-400',
};

export function MarketAnalysis() {
  return (
    <section id="market" className="py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-emerald-400">
            El mercado
          </span>
          <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">
            Medio millon de personas.{' '}
            <span className="bg-gradient-to-r from-emerald-400 to-emerald-500 bg-clip-text text-transparent">
              Ninguna solucion completa.
            </span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-slate-400">
            La Regularizacion Extraordinaria 2026 genera la mayor demanda de servicios migratorios en la historia de Espana.
            Hay 21 competidores. Ninguno tiene tecnologia. Nosotros si.
          </p>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-2">
          {/* TAM/SAM/SOM */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-md"
          >
            <h3 className="mb-6 text-sm font-semibold uppercase tracking-wider text-slate-400">Tamano del Mercado</h3>
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="flex h-56 w-56 items-center justify-center rounded-full border border-slate-600/30 bg-slate-800/40">
                  <div className="flex h-40 w-40 items-center justify-center rounded-full border border-blue-500/30 bg-blue-500/10">
                    <div className="flex h-24 w-24 items-center justify-center rounded-full border border-emerald-400/40 bg-emerald-500/20">
                      <div className="text-center">
                        <p className="text-lg font-bold text-emerald-400">20K</p>
                        <p className="text-[10px] text-emerald-300">Nuestro objetivo</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="absolute -right-2 top-2 rounded-lg border border-white/10 bg-[#0f1b2e] px-2 py-1 text-xs text-slate-300">
                  500K personas irregulares
                </div>
                <div className="absolute -right-2 top-14 rounded-lg border border-blue-400/20 bg-[#0f1b2e] px-2 py-1 text-xs text-blue-400">
                  200K buscan abogado activamente
                </div>
              </div>
            </div>
            <div className="mt-6 space-y-2">
              <div className="flex justify-between rounded-lg border border-white/5 bg-white/[0.03] px-3 py-2 text-xs">
                <span className="text-slate-400">Abogados de extranjeria en Espana</span>
                <span className="font-semibold text-slate-300">~5,000</span>
              </div>
              <div className="flex justify-between rounded-lg border border-emerald-500/20 bg-emerald-500/[0.05] px-3 py-2 text-xs">
                <span className="text-slate-300 font-medium">Migro capta un contacto por</span>
                <span className="font-bold text-emerald-400">2 EUR</span>
              </div>
              <div className="flex justify-between rounded-lg border border-orange-500/20 bg-orange-500/[0.05] px-3 py-2 text-xs">
                <span className="text-slate-300 font-medium">La industria paga por contacto</span>
                <span className="font-bold text-orange-400">5-15 EUR</span>
              </div>
            </div>
          </motion.div>

          {/* Competitors */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-md"
          >
            <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-slate-400">21 competidores identificados</h3>
            <p className="mb-4 text-xs text-slate-500">Ninguno combina IA + CRM + Fintech. Todos son despachos tradicionales o webs de leads.</p>
            <div className="space-y-2">
              {competitors.map((comp, i) => (
                <motion.div
                  key={comp.name}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.05 * i }}
                  className="flex items-center justify-between rounded-lg border border-white/5 bg-white/[0.03] px-3 py-2.5"
                >
                  <div className="flex-1">
                    <p className="text-sm font-medium text-slate-200">{comp.name}</p>
                    <p className="text-xs text-slate-500">{comp.weakness}</p>
                  </div>
                  <span className="mr-3 text-xs font-semibold text-slate-400">{comp.price}</span>
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${threatColor[comp.threat]}`}>
                    {comp.threat}
                  </span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Differentiators */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-6 rounded-2xl border border-emerald-500/20 bg-emerald-500/[0.04] p-6 backdrop-blur-md"
        >
          <h3 className="mb-2 text-sm font-semibold uppercase tracking-wider text-emerald-400">Por que Migro no se puede copiar facilmente</h3>
          <p className="mb-4 text-xs text-slate-400">Hemos construido durante 2 anos una plataforma con 112 tablas, 500+ endpoints, 5 agentes IA y 30+ integraciones. Es un moat real.</p>
          <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
            {differentiators.map((d, i) => (
              <div key={i} className="flex items-start gap-2.5 rounded-lg border border-white/5 bg-white/[0.03] p-3">
                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/20">
                  <svg className="h-3 w-3 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs font-semibold text-slate-200">{d.feature}</p>
                  <p className="text-[10px] text-slate-500">{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
